import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';

export default function FavouritesAnalytics() {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [total,   setTotal]   = useState(0);

  useEffect(() => {
    const load = async () => {
      const { data: rows } = await supabase
        .from('favourites')
        .select('product_id, product_name, product_brand, product_image, product_price');

      if (!rows) { setLoading(false); return; }

      // Count per product
      const counts = {};
      rows.forEach(r => {
        const k = r.product_id;
        if (!counts[k]) {
          counts[k] = { ...r, count: 0 };
        }
        counts[k].count += 1;
      });

      const sorted = Object.values(counts).sort((a, b) => b.count - a.count);
      setData(sorted);
      setTotal(rows.length);
      setLoading(false);
    };
    load();
  }, []);

  const max = data[0]?.count || 1;

  return (
    <div>
      <div className="ad__header">
        <div>
          <h1 className="ad__title">Favourites</h1>
          <p className="ad__subtitle">
            {total} total saves across {data.length} product{data.length !== 1 ? 's' : ''}
          </p>
        </div>
      </div>

      {loading ? (
        <div className="ad__loading">Loading analytics...</div>
      ) : data.length === 0 ? (
        <div className="ad__empty">
          <p>No favourites yet. They'll show up here when users start saving products.</p>
        </div>
      ) : (
        <div className="ad__table-wrap">
          <table className="ad__table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Product</th>
                <th>Brand</th>
                <th>Price</th>
                <th>Saves</th>
                <th>Popularity</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, i) => (
                <tr key={item.product_id}>
                  <td>
                    <span style={{
                      fontFamily: 'Six Caps, sans-serif',
                      fontSize: 22,
                      color: i === 0 ? '#da291c' : i === 1 ? '#e8b400' : '#aaa',
                    }}>
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </td>
                  <td>
                    <div className="ad__product-cell">
                      {item.product_image && (
                        <img src={item.product_image} alt={item.product_name} className="ad__thumb" />
                      )}
                      <p className="ad__product-name">{item.product_name}</p>
                    </div>
                  </td>
                  <td className="ad__cell-muted">{item.product_brand}</td>
                  <td className="ad__cell-price">
                    R {item.product_price?.toLocaleString()}
                  </td>
                  <td>
                    <span style={{
                      fontFamily: 'Six Caps, sans-serif',
                      fontSize: 24,
                      color: '#171717',
                    }}>
                      {item.count}
                    </span>
                    <span style={{
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: 10,
                      color: '#aaa',
                      marginLeft: 4,
                    }}>
                      save{item.count !== 1 ? 's' : ''}
                    </span>
                  </td>
                  <td style={{ width: 160 }}>
                    <div style={{
                      height: 6,
                      background: '#f0f0f0',
                      borderRadius: 3,
                      overflow: 'hidden',
                    }}>
                      <div style={{
                        height: '100%',
                        width: `${(item.count / max) * 100}%`,
                        background: i === 0 ? '#da291c' : '#171717',
                        borderRadius: 3,
                        transition: 'width .4s ease',
                      }} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}